"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 */ class $a5fd07fa01589658$var$Game {
    static GAME_STATUS = {
        IDLE: "idle",
        PLAYING: "playing",
        WIN: "win",
        LOSE: "lose"
    };
    static ROW_LENGTH = 4;
    static COL_LENGTH = 4;
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = Array.from({
        length: 4
    }, ()=>Array(4).fill(0))){
        this.status = $a5fd07fa01589658$var$Game.GAME_STATUS.IDLE;
        this.score = 0;
        this.initialState = initialState.map((row)=>[
                ...row
            ]);
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
    }
    /**
   * Starts the game.
   */ start() {
        this.status = $a5fd07fa01589658$var$Game.GAME_STATUS.PLAYING;
        this.addNewCell();
        this.addNewCell();
    }
    /**
   * Resets the game.
   */ restart() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.status = $a5fd07fa01589658$var$Game.GAME_STATUS.IDLE;
        this.score = 0;
    }
    moveLeft() {
        if (this.status !== $a5fd07fa01589658$var$Game.GAME_STATUS.PLAYING) return;
        const previousState = this.state.map((row)=>[
                ...row
            ]);
        for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++){
            let row = this.state[rowIndex].filter((cell)=>cell !== 0);
            if (row.length === 0) continue;
            for(let colIndex = 0; colIndex < row.length - 1; colIndex++){
                if (row[colIndex] === 0) continue;
                if (row[colIndex] === row[colIndex + 1]) {
                    row[colIndex] *= 2;
                    row[colIndex + 1] = 0;
                    this.score += row[colIndex];
                }
            }
            row = row.filter((cell)=>cell !== 0);
            while(row.length < $a5fd07fa01589658$var$Game.COL_LENGTH)row.push(0);
            this.state[rowIndex] = row;
        }
        if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
        this.checkWinLose();
    }
    moveRight() {
        if (this.status !== $a5fd07fa01589658$var$Game.GAME_STATUS.PLAYING) return;
        const previousState = this.state.map((row)=>[
                ...row
            ]);
        for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++){
            let row = this.state[rowIndex].filter((cell)=>cell !== 0);
            if (row.length === 0) continue;
            for(let colIndex = row.length - 1; colIndex > 0; colIndex--){
                if (row[colIndex] === 0) continue;
                if (row[colIndex] === row[colIndex - 1]) {
                    row[colIndex] *= 2;
                    row[colIndex - 1] = 0;
                    this.score += row[colIndex];
                }
            }
            row = row.filter((cell)=>cell !== 0);
            while(row.length < $a5fd07fa01589658$var$Game.COL_LENGTH)row.unshift(0);
            this.state[rowIndex] = row;
        }
        if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
        this.checkWinLose();
    }
    moveUp() {
        if (this.status !== $a5fd07fa01589658$var$Game.GAME_STATUS.PLAYING) return;
        const previousState = this.state.map((row)=>[
                ...row
            ]);
        for(let colIndex = 0; colIndex < $a5fd07fa01589658$var$Game.COL_LENGTH; colIndex++){
            let column = [];
            for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++)if (this.state[rowIndex][colIndex] !== 0) column.push(this.state[rowIndex][colIndex]);
            for(let i = 0; i < column.length - 1; i++){
                if (column[i] === 0) continue;
                if (column[i] === column[i + 1]) {
                    column[i] *= 2;
                    column[i + 1] = 0;
                    this.score += column[i];
                }
            }
            column = column.filter((cell)=>cell !== 0);
            while(column.length < $a5fd07fa01589658$var$Game.ROW_LENGTH)column.push(0);
            for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++)this.state[rowIndex][colIndex] = column[rowIndex];
        }
        if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
        this.checkWinLose();
    }
    moveDown() {
        if (this.status !== $a5fd07fa01589658$var$Game.GAME_STATUS.PLAYING) return;
        const previousState = this.state.map((row)=>[
                ...row
            ]);
        for(let colIndex = 0; colIndex < $a5fd07fa01589658$var$Game.COL_LENGTH; colIndex++){
            let column = [];
            for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++)if (this.state[rowIndex][colIndex] !== 0) column.push(this.state[rowIndex][colIndex]);
            for(let i = column.length - 1; i > 0; i--){
                if (column[i] === 0) continue;
                if (column[i] === column[i - 1]) {
                    column[i] *= 2;
                    column[i - 1] = 0;
                    this.score += column[i];
                }
            }
            column = column.filter((cell)=>cell !== 0);
            while(column.length < $a5fd07fa01589658$var$Game.ROW_LENGTH)column.unshift(0);
            for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++)this.state[rowIndex][colIndex] = column[rowIndex];
        }
        if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
        this.checkWinLose();
    }
    statesAreEqual(state1, state2) {
        return state1.flat().join() === state2.flat().join();
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.state;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    addNewCell() {
        const emptyCells = [];
        this.state.forEach((row, rowIndex)=>{
            row.forEach((cell, cellIndex)=>{
                if (cell === 0) emptyCells.push([
                    rowIndex,
                    cellIndex
                ]);
            });
        });
        const [r, c] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        this.state[r][c] = Math.random() < 0.9 ? 2 : 4;
    }
    checkWinLose() {
        if (this.state.flat().includes(2048)) this.status = $a5fd07fa01589658$var$Game.GAME_STATUS.WIN;
        else if (!this.state.flat().includes(0) && !this.checkMergePossible()) this.status = $a5fd07fa01589658$var$Game.GAME_STATUS.LOSE;
    }
    checkMergePossible() {
        for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH; rowIndex++)for(let colIndex = 0; colIndex < $a5fd07fa01589658$var$Game.COL_LENGTH; colIndex++){
            if (colIndex < $a5fd07fa01589658$var$Game.COL_LENGTH - 1 && this.state[rowIndex][colIndex] === this.state[rowIndex][colIndex + 1]) return true;
            if (rowIndex < $a5fd07fa01589658$var$Game.ROW_LENGTH - 1 && this.state[rowIndex][colIndex] === this.state[rowIndex + 1][colIndex]) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startBtn = document.querySelector(".start");
const $09e991522ca7e64e$var$startMsg = document.querySelector(".message-start");
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$winMsg = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMsg = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$cellNodes = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$cells = [
    ...$09e991522ca7e64e$var$cellNodes
];
const $09e991522ca7e64e$var$updateCells = ()=>{
    $09e991522ca7e64e$var$cells.forEach((cell, index)=>{
        const rowIndex = Math.floor(index / $a5fd07fa01589658$exports.COL_LENGTH);
        const colIndex = index % $a5fd07fa01589658$exports.COL_LENGTH;
        const cellValue = $09e991522ca7e64e$var$game.state[rowIndex][colIndex];
        cell.textContent = cellValue || "";
        cell.className = "field-cell";
        if (cellValue) cell.classList.add(`field-cell--${cellValue}`);
    });
    $09e991522ca7e64e$var$scoreEl.textContent = $09e991522ca7e64e$var$game.getScore();
};
const $09e991522ca7e64e$var$handleArrowPress = (e)=>{
    switch(e.key){
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        default:
            break;
    }
    $09e991522ca7e64e$var$updateCells();
    if ($09e991522ca7e64e$var$game.status === $a5fd07fa01589658$exports.GAME_STATUS.WIN) $09e991522ca7e64e$var$winMsg.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.status === $a5fd07fa01589658$exports.GAME_STATUS.LOSE) $09e991522ca7e64e$var$loseMsg.classList.remove("hidden");
};
const $09e991522ca7e64e$var$handleStart = ()=>{
    if ($09e991522ca7e64e$var$game.status === $a5fd07fa01589658$exports.GAME_STATUS.IDLE) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startBtn.textContent = "Restart";
        $09e991522ca7e64e$var$startBtn.classList.add("restart");
        $09e991522ca7e64e$var$startBtn.classList.remove("start");
        $09e991522ca7e64e$var$startMsg.classList.add("hidden");
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startBtn.textContent = "Start";
        $09e991522ca7e64e$var$loseMsg.classList.add("hidden");
        $09e991522ca7e64e$var$winMsg.classList.add("hidden");
        $09e991522ca7e64e$var$startBtn.classList.add("start");
        $09e991522ca7e64e$var$startBtn.classList.remove("restart");
        $09e991522ca7e64e$var$startMsg.classList.remove("hidden");
    }
    document.addEventListener("keydown", $09e991522ca7e64e$var$handleArrowPress);
    $09e991522ca7e64e$var$updateCells();
    if ($09e991522ca7e64e$var$game.status !== $a5fd07fa01589658$exports.GAME_STATUS.PLAYING) document.removeEventListener("keydown", $09e991522ca7e64e$var$handleArrowPress);
};
$09e991522ca7e64e$var$startBtn.addEventListener("click", $09e991522ca7e64e$var$handleStart);


//# sourceMappingURL=index.96f8be47.js.map
